import { z } from 'zod'

import type { SubtitleLine } from '../types'

export const AI_MESSAGE_CMD_ID = 1

const SubtitleSchema = z.object({
  type: z.literal(10_000),
  sender: z.string(),
  payload: z.object({
    text: z.string().max(10_000),
    roundid: z.string().optional().default(''),
    end: z.boolean().optional().default(false),
  }),
})

const StateSchema = z.object({
  type: z.literal(10_001),
  payload: z.object({ state: z.number().int(), roundid: z.string().optional() }),
})

export function parseTRTCMessage(
  data: ArrayBuffer,
  currentUserId: string,
): { subtitle?: SubtitleLine; state?: number } | null {
  try {
    const json: unknown = JSON.parse(new TextDecoder().decode(data))
    const subtitle = SubtitleSchema.safeParse(json)
    if (subtitle.success) {
      const text = subtitle.data.payload.text.trim()
      if (!text) return null
      const speaker = subtitle.data.sender === currentUserId ? 'user' : 'assistant'
      return {
        subtitle: {
          key: `${subtitle.data.payload.roundid}:${subtitle.data.sender}`,
          speaker,
          text,
          final: subtitle.data.payload.end,
        },
      }
    }
    const state = StateSchema.safeParse(json)
    return state.success ? { state: state.data.payload.state } : null
  } catch {
    return null
  }
}
